import { RESET_PRODUCTS_FORM } from '../actionTypes';
import { installerProfileActions } from '../reducer';

export default () => installerProfileActions[RESET_PRODUCTS_FORM]();
